import { render, staticRenderFns } from "./addProductBtn.vue?vue&type=template&id=2d60a380&scoped=true&lang=pug&"
import script from "./addProductBtn.vue?vue&type=script&lang=js&"
export * from "./addProductBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d60a380",
  null
  
)

export default component.exports